angular.module('autoremind.satellites', [])
    .controller('autoremind.satellites.ScreenController', ['$scope', '$location', '$log', 'logger', 'userProfile', 'satelliteService', 'userSettings', 'accountService',
    function ($scope, $location, $log, logger, userProfile, satelliteService, userSettings, accountService) {
        console.log('Inside satellites.ScreenController');
        $scope.userProfile = userProfile;
        $scope.userSettings = userSettings;
        userProfile.initalizeViewModel("admin");
        if (!angular.isDefined(userProfile.viewModel.views.admin)) {
            userProfile.viewModel.views.admin = {};
        }
        if (!angular.isDefined(userProfile.viewModel.views.admin.satellites)) {
            userProfile.viewModel.views.admin.satellites = {
                activeTabIndex: 0,
                tabIndexes: {
                    setup: 0,
                    satellites: 1,
                    lasterrors: 2,
                    errors: 3
                },
                loadingIndicator: {
                    'state': false, 'refCount': 0
                }
            };
            userProfile.viewModel.views.admin.satellites.tabViews = {
                // State for tabs
                setup: {},
                satellites: {},
                errors: {},
                lasterrors: {}
            };
        }
        $scope.viewModel = userProfile.viewModel.views.admin.satellites;
        /**
         * This is called both on initialising the controller and when clicking on a tab.
         * When loading the page and opening the tab based on route - the controller will first
         * call setRoute() and then the view's 'select' will call it as well. In that case we just
         * ignore the call.
         */
        $scope.setRoute = function (tabName, source) {
            console.log('setRoute(tab=' + tabName + ', source=' + source + ')');
            if ($location.path() === '/admin/satellites/' + tabName && source === 'UI') {
                console.log('setRoute() ignored because of no changes');
                return;
            }
            $scope.resolveUser();
            var userId = $location.search().userid;
            if (userId === undefined) {
                userId = accountService.selectedUserId;
            }
            var tab = tabName;
            if (!angular.isDefined($scope.viewModel.tabIndexes[tabName])) {
                tab = 'setup';
            }
            if (tab === 'setup' && !userId) {
                // If no userId then switch to Satellite Surveillance tab
                if (+$location.search().userid === 0) {
                    // If set in path but zero - then remove from path
                    $location.search('userid', null);
                }
                tab = 'satellites';
            }
            $scope.viewModel.activeTabIndex = $scope.viewModel.tabIndexes[tab];
            var newPath = '/admin/satellites/' + tab;
            logger.debug('selecting tab ' + tab + ' ' + $location.path() + ' -> ' + newPath);
            if ($location.path() !== newPath) {
                if (!userId) {
                    $location.path(newPath);
                    //$location.path(newPath, false);
                }
                else {
                    // NOTE: I'm not sure this will actual avoid reload when setting path parameters
                    $location.path(newPath, false).search({ userid: accountService.selectedUserId });
                }
            }
        };
        $scope.searchUsersList = function (pattern) {
            $scope.viewModel.detailsVisible = false;
            return accountService.searchUser(pattern, $scope.viewModel.loadingIndicator)
                .then(function (users) {
                $scope.viewModel.usersList = users;
                return users;
            });
        };
        $scope.getSelectedUserData = function () {
            if ($scope.viewModel.selectedUser === null) {
                return;
            }
            $scope.viewModel.userId = $scope.viewModel.selectedUser.userId;
            $scope.viewModel.selectedUserInfo = {
                // Set name of new user - to show this in stead of old user name in the view
                userName: $scope.viewModel.selectedUser.name,
                userId: $scope.viewModel.selectedUser.userId
            };
            if ($location.search().user && $location.search().user !== $scope.viewModel.selectedUser.name) {
                // NOTE: I'm not sure this will actual avoid reload when setting path parameters
                $location.path($location.path(), false)
                    .search('userid', $scope.viewModel.selectedUser.userId)
                    .search('user', null);
            }
            else {
                $location.search('userid', $scope.viewModel.selectedUser.userId);
            }
        };
        /**
         * Only run this once when the page loads (not on changing tabs)
         */
        $scope.init = function () {
            console.log('satellites.ScreenController.init() - path=', $location.path());
            satelliteService.getUserStatuses();
            switch ($location.path()) {
                case '/admin/satellites/':
                case '/admin/satellites/setup':
                    $scope.setRoute('setup');
                    break;
                case '/admin/satellites/satellites':
                    $scope.setRoute('satellites');
                    break;
                case '/admin/satellites/lasterrors':
                    $scope.setRoute('lasterrors');
                    break;
                case '/admin/satellites/errors':
                    $scope.setRoute('errors');
                    break;
            }
            $scope.getUser();
        };
        $scope.resolveUser = function () {
            $scope.viewModel.selectedUserName = $location.search().user;
            // If we get only userName in the path and no userId - it is probably a request to switch to a
            // different user, so we need to clear the userId
            if ($scope.viewModel.selectedUserName && !$location.search().userid) {
                $scope.viewModel.userId = 0;
                accountService.setSelectedUser(undefined);
                accountService.selectedUser = undefined;
                $scope.viewModel.selectedUserInfo = {
                    // Set name of new user - to show this in stead of old user name in the view
                    userName: $scope.viewModel.selectedUserName
                };
            }
            $scope.viewModel.userId = +($location.search().userid || accountService.selectedUserId);
            if (+$scope.viewModel.userId === 0) {
                if ($location.search().userid !== undefined && +$location.search().userid === 0) {
                    // If set in path but zero - then remove from path
                    $location.search('userid', null);
                }
            }
            // accountService.setSelectedUser($scope.viewModel.userId); // TODO: only do this if set from path?
        };
        $scope.getUser = function () {
            if ($scope.viewModel.userId > 0 || $scope.viewModel.selectedUserName) {
                accountService.getUser($scope.viewModel.userId, $scope.viewModel.selectedUserName, $scope.viewModel.loadingIndicator)
                    .then(function (user) {
                    $scope.viewModel.selectedUserInfo = user;
                    // $scope.viewModel.selectedUser = user;
                    if (!$scope.viewModel.userId) {
                        $scope.viewModel.userId = user.userId;
                        if ($location.search().userid === undefined) {
                            console.log('Adding userId=' + user.userId + ' to path');
                            // NOTE: I'm not sure this will actual avoid reload when setting path parameters
                            $location.path($location.path(), false).search('userid', $scope.viewModel.userId);
                        }
                    }
                    else {
                        if ($location.search().user && $location.search().user !== user.userName) {
                            console.log('removing username (not matching userId) from path');
                            // NOTE: I'm not sure this will actual avoid reload when setting path parameters
                            $location.path($location.path(), false).search('user', null);
                        }
                        accountService.setSelectedUser(user);
                    }
                });
            }
        };
        $scope.init();
    }]);
//# sourceMappingURL=satellites.controllers.js.map